import React from 'react';
import { Page, PageHeader, PageBody } from "../base/Page";
import { Button, Row, Col, Panel, FormGroup, FormControl, ControlLabel } from 'react-bootstrap';
import API from "../base/API";
import { browserHistory } from "react-router";
import Auth from "../auth/Auth";
import { translate } from "../base/Translation";

export default class ProtocolNew extends Auth {

	constructor(props) {
		super(props);

		this.api = new API({
			save_protocol: "/protocol/save/new",
			get_forms: "/form/fetch/all",
			get_errors: "/error_db/fetch/all",
			get_clients: "/protocol/fetch/by/role/:role"
		});

		this.state = {
			protocol: {
				id: 0,
				name: translate("Nový protokol"),
				form: 0,
				form_point_weight: 0,
				error_db: 0,
				error_db_point_weight: 0,
				max_errors: 0
			},
			forms: null,
			error_dbs: null
		};
	}

	fetchData() {

		this.api.request({
			route: "get_errors",
			success: (response) => {
				this.setState({ error_dbs: response });
			}
		});

		this.api.request({
			route: "get_forms",
			success: (response) => {
				this.setState({ forms: response });
			}
		});
	}

	componentDidMount() {
		this.fetchData();
	}

	onChange(evt) {
		// Get protocol from state
		let newProtocol = this.state.protocol;

		// Update it's value
		newProtocol[evt.target.name] = evt.target.value;

		// Update vehicle in state
		this.setState({ protocol: newProtocol });
	}

	onSave(evt) {
		this.api.request({
			route: "save_protocol",
			data: this.state.protocol,
			created: (response) => {
				browserHistory.push("/protocols");
			}
		});
	}

	renderOptions(data) {
		let options = data.map(function (item) {
			return (
				<option value={item.id} key={item.id}>{typeof item.name !== "undefined" ? item.name : item.email}</option>
			)
		});

		return (options);
	}

	render() {

		if (this.state.protocol === null || this.state.forms === null || this.state.error_dbs === null) {
			return (
				<Page>
					<PageHeader>{translate("Prosím počkajte")}</PageHeader>
					<PageBody>{translate("Obsah sa načítava")}</PageBody>
				</Page>
			);
		}

		return (
			<Page>
				<PageHeader title={this.state.protocol.name} />
				<PageBody>
					<Row>
						<Col lg={6}>
							<Panel header={translate("Základné")}>
								<FormGroup>
									<ControlLabel>{translate("Názov")}</ControlLabel>
									<FormControl defaultValue={this.state.protocol.name} name="name" onChange={this.onChange.bind(this)} />
								</FormGroup>
								<FormGroup>
									<ControlLabel>{translate("Dotazník")}</ControlLabel>
									<FormControl componentClass="select" name="form" defaultValue={this.state.protocol.form}
										onChange={this.onChange.bind(this)}>
										<option value={0}>{translate("Vyberte")}</option>
										{this.renderOptions(this.state.forms)}
									</FormControl>
								</FormGroup>
								<FormGroup>
									<ControlLabel>{translate("Bodová váha dotazníka")}</ControlLabel>
									<FormControl defaultValue={this.state.protocol.form_point_weight} name="form_point_weight" onChange={this.onChange.bind(this)} />
								</FormGroup>

								<FormGroup>
									<ControlLabel>{translate("Databáza chýb")}</ControlLabel>
									<FormControl componentClass="select" name="error_db" defaultValue={this.state.protocol.error_db}
										onChange={this.onChange.bind(this)}>
										<option value={0}>{translate("Vyberte")}</option>
										{this.renderOptions(this.state.error_dbs)}
									</FormControl>
								</FormGroup>
								<FormGroup>
									<ControlLabel>{translate("Bodová váha databázy chýb")}</ControlLabel>
									<FormControl defaultValue={this.state.protocol.error_db_point_weight} name="error_db_point_weight" onChange={this.onChange.bind(this)} />
								</FormGroup>

								<FormGroup>
									<ControlLabel>{translate("Maximálny počet chýb")}</ControlLabel>
									<FormControl defaultValue={this.state.protocol.max_errors} name="max_errors" onChange={this.onChange.bind(this)} />
								</FormGroup>

							</Panel>
						</Col>
					</Row>
					<Row>
						<Col lg={12}>
							<FormGroup>
								<Button bsStyle="success" onClick={this.onSave.bind(this)}>{translate("Uložiť")}</Button>
							</FormGroup>
						</Col>
					</Row>
				</PageBody>
			</Page>
		);
	}
}


// WEBPACK FOOTER //
// ./src/modules/protocol/ProtocolNew.js